const getDropdownOptionBackground = (state, { primaryColour }) => {
  let color = '';
  if (state.isFocused && !state.isSelected) {
    color = '#ebeeef';
  } else if (state.isSelected || state.isActive) {
    color = primaryColour;
  }

  return color;
};

const getDefaultStyles = (whiteLabelSettings = {}) => {
  return {
    indicatorSeparator: (provided) => ({
      ...provided,
      background: '#fff',
    }),
    option: (provided, state) => ({
      color: state.isSelected ? '#fff' : '#000',
      background: getDropdownOptionBackground(state, whiteLabelSettings),
    }),
  };
};

export const getTabSelectorDropdownStyles = (whiteLabelSettings = {}) => {
  const { primaryColour } = whiteLabelSettings;

  return {
    ...getDefaultStyles(whiteLabelSettings),
    control: (provided) => ({
      ...provided,
      border: '1px solid transparent',
      ':hover': {
        border: '1px solid transparent',
      },
      background: '#fff',
      padding: '0.5rem 1.5rem',
      color: primaryColour,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: primaryColour,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: primaryColour,
      fontWeight: '700',
    }),
    option: (provided, state) => ({
      padding: '0.5rem 2rem',
      color: state.isSelected ? '#fff' : '#000',
      background: getDropdownOptionBackground(state, whiteLabelSettings),
    }),
  };
};

const getBorder = (state, { secondaryColourDarker }, hasError) => {
  if (hasError) {
    return '1px solid #d02949 !important';
  }

  return state.isFocused
    ? `1px solid ${secondaryColourDarker} !important`
    : '1px solid #e4e4e7 !important';
};

export const getSelectFieldStyles = (
  whiteLabelSettings = {},
  hasError = false,
  isDisabled = false
) => {
  const { primaryColour } = whiteLabelSettings;

  return {
    ...getDefaultStyles(whiteLabelSettings),
    control: (provided, state) => ({
      ...provided,
      border: isDisabled
        ? '1px solid #d1d5db'
        : getBorder(state, whiteLabelSettings, hasError),
      background: isDisabled ? '#e5e7eb' : '#fff',
      color: isDisabled ? '#9ca3af' : '#000',
      cursor: isDisabled ? 'not-allowed' : 'default',
      ':hover': {
        border: isDisabled
          ? '1px solid #d1d5db'
          : getBorder(state, whiteLabelSettings, hasError),
      },
      boxShadow: 'none !important',
      outline: 'none !important',
      height: '50px',
      borderRadius: '10px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: isDisabled ? '#9ca3af' : primaryColour,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: isDisabled ? '#9ca3af' : provided.color,
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 1060,
    }),
    menuList: (provided) => ({
      ...provided,
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',
      boxSizing: 'border-box',
      paddingBottom: '0.5rem',
    }),
    option: () => ({
      padding: '0.5rem 1rem',
    }),
  };
};
